import { throttle } from "throttle-debounce"
import { createDelegator, toggleClass } from "./domHelpers"
import sleep from "./sleep"

async function scrollLeft(el, position, callback) {
  const steps = 10
  const current = el.scrollLeft
  const step = (position - current) / steps

  for (let i = 0; i < steps; i++) {
    el.scrollLeft = current + (i + 1) * step

    await sleep(20)
  }

  callback()
}

export default function Slider(node) {
  const items = node.querySelector(".slider-items")
  if (!items) return

  const sliderItemsArray = Array.from(node.querySelectorAll(".slider-item"))
  if (sliderItemsArray.length === 0) return

  const sliderLeft = node.querySelector(".slider-left")
  const sliderRight = node.querySelector(".slider-right")

  const dotsArray = Array.from(node.querySelectorAll(".slider-dot"))

  const initialCurrent = node.querySelector(".slider-item-current") || node.querySelector(".slider-item")
  initialCurrent?.classList?.add("slider-item-current")

  const scrollToCurrent = (callback = null) => {
    const current = node.querySelector(".slider-item-current")
    if (!current) return

    const position = items.scrollLeft + current.getBoundingClientRect().left + current.offsetWidth / 2 - items.offsetWidth / 2 - items.getBoundingClientRect().left

    callback ? scrollLeft(items, position, callback) : items.scrollLeft = position
  }

  const updateNavi = () => {
    [sliderLeft, sliderRight].filter((el) => el).forEach((el) => {
      toggleClass(el, "is-hidden", items.scrollWidth <= items.offsetWidth + 5)
    })

    if (sliderLeft) toggleClass(sliderLeft, "is-disabled", items.scrollLeft <= 5)
    if (sliderRight) toggleClass(sliderRight, "is-disabled", items.scrollLeft + items.offsetWidth >= items.scrollWidth - 5)

    const index = sliderItemsArray.indexOf(node.querySelector(".slider-item-current"))
    if (index < 0) return

    dotsArray.forEach((el) => el.classList.remove("is-current"))
    dotsArray[index]?.classList?.add("is-current")
  }

  node.slideTo = (slide) => {
    if (!sliderItemsArray[slide]) return

    sliderItemsArray.forEach((el) => el.classList.remove("slider-item-current"))
    sliderItemsArray[slide].classList.add("slider-item-current")

    scrollToCurrent(() => updateNavi())
  }

  const slidesPerPage = () => {
    return Math.max(1, initialCurrent.offsetWidth ? Math.floor(items.offsetWidth / initialCurrent.offsetWidth) : 0)
  }

  sliderLeft?.addEventListener("click", (e) => {
    e.preventDefault()

    if (sliderLeft.classList.contains("is-disabled")) return
    sliderLeft.classList.add("is-disabled")

    node.slideTo(sliderItemsArray.indexOf(node.querySelector(".slider-item-current")) - slidesPerPage())
  })

  sliderRight?.addEventListener("click", (e) => {
    e.preventDefault()

    if (sliderRight.classList.contains("is-disabled")) return
    sliderRight.classList.add("is-disabled")

    node.slideTo(sliderItemsArray.indexOf(node.querySelector(".slider-item-current")) + slidesPerPage())
  })

  node.addEventListener("click", createDelegator(".slider-dot", (e) => {
    e.preventDefault()

    node.slideTo(dotsArray.indexOf(e.delegateTarget))
  }))

  let initialScroll = 0, initialWindowScroll = 0, initialTouchX = 0, lastTouchX = 0

  items.addEventListener("touchstart", (e) => {
    initialScroll = items.scrollLeft
    initialWindowScroll = window.scrollTop
    initialTouchX = e.touches[0].clientX
    lastTouchX = e.touches[0].clientX
  })

  items.addEventListener("touchmove", (e) => {
    lastTouchX = e.touches[0].clientX
    items.scrollLeft = initialScroll + initialTouchX - lastTouchX
  })

  items.addEventListener("touchend", (e) => {
    const index = sliderItemsArray.indexOf(node.querySelector(".slider-item-current"))
    const diff = initialTouchX - lastTouchX

    Math.abs(diff) < 40 ? node.slideTo(index) : node.slideTo(diff > 0 ? index + 1 : index - 1)
  })

  const onResize = throttle(150, () => {
    scrollToCurrent()
    updateNavi()
  })

  window.addEventListener("resize", onResize)

  scrollToCurrent()
  updateNavi()

  return () => {
    window.removeEventListener("resize", onResize)
  }
}
